module.exports = __webpack_public_path__ + "static/media/resume.6daef948.pdf";